import * as React from 'react';
import { DateFilter } from '../DateFilter';
import { Pagination } from '../Pagination';
import { Loader } from '../Loader';
import { injectIntl, useIntl } from 'react-intl';
import { TranslateText } from '../TranslateText';
import { HintMessage } from '../HintMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const detailRowRandomId = (Math.random() + 1).toString(36).substring(8);
export let HeaderValueType = /*#__PURE__*/function (HeaderValueType) {
  HeaderValueType["Image"] = "Image";
  HeaderValueType["Checkbox"] = "Checkbox";
  HeaderValueType["AutoIncrement"] = "AutoIncrement";
  HeaderValueType["DetailRow"] = "DetailRow";
  HeaderValueType["ExternalLink"] = "ExternalLink";
  HeaderValueType["Color"] = "Color";
  return HeaderValueType;
}({});

// Make sure this enum values are css text-align property value compatible
export let TextAlignmentType = /*#__PURE__*/function (TextAlignmentType) {
  TextAlignmentType["Left"] = "left";
  TextAlignmentType["Right"] = "right";
  TextAlignmentType["Center"] = "center";
  return TextAlignmentType;
}({});
export let FilterTypeProps = /*#__PURE__*/function (FilterTypeProps) {
  FilterTypeProps["Danger"] = "danger";
  FilterTypeProps["Warning"] = "warning";
  return FilterTypeProps;
}({});
export let SortByType = /*#__PURE__*/function (SortByType) {
  SortByType["Asc"] = "asc";
  SortByType["Desc"] = "desc";
  return SortByType;
}({});
const _TableHeadItem = ({
  item,
  sortField,
  setSortField,
  sortOrder,
  setSortOrder,
  tableData,
  setTableData,
  onClickCheckbox
}) => {
  const sortByKey = item.sortKey || item.key;
  const sortIcon = sortField === sortByKey && item.sort && sortOrder === SortByType.Asc ? "kc-ui-sort-asc" : sortField === sortByKey && item.sort && sortOrder === SortByType.Desc ? "kc-ui-sort-desc" : "kc-ui-sort";
  const headerStyle = {
    width: item?.width,
    textAlign: item?.textAlign
  };
  const onTriggerHeaderClick = item => {
    setSortField(item.sortKey || item.key);
    const sortOrderValue = sortField === sortByKey ? sortOrder === SortByType.Asc ? SortByType.Desc : SortByType.Asc : SortByType.Asc;
    setSortOrder(sortOrderValue);
    let orderedList = tableData && sortByKey && sortByKey !== "" ? tableData.sort((a, b) => {
      if (a[sortByKey] > b[sortByKey]) {
        return sortOrderValue === SortByType.Asc ? 1 : -1;
      } else if (a[sortByKey] < b[sortByKey]) {
        return sortOrderValue === SortByType.Asc ? -1 : 1;
      } else {
        return 0;
      }
    }) : tableData;
    setTableData(orderedList);
  };
  if (item.type === HeaderValueType.Checkbox) {
    const randomHeaderCheckboxId = (Math.random() + 1).toString(36).substring(5);
    const checkedData = tableData && typeof tableData === "object" ? tableData.filter(i => i[item.key] === true).length : [];
    const isChecked = tableData.length ? checkedData === tableData.length : false;
    return /*#__PURE__*/_jsx("li", {
      title: item.tite,
      className: `${item.sort ? "kc-ui-cursor" : ""} kc-ui-checkbox ${isChecked ? 'checked' : ''}`,
      onClick: () => {
        if (onClickCheckbox) {
          let tableDataValue = tableData.map(prevData => {
            return {
              ...prevData,
              [item.key]: !isChecked
            };
          });
          let allSelected = false;
          const checkedNewData = tableDataValue.filter(i => i[item.key] === true).length;
          if (checkedNewData !== 0 && checkedNewData === tableData.length) {
            allSelected = true;
          }
          onClickCheckbox({
            items: tableDataValue?.filter(i => i[item.key] === true),
            column: item,
            allSelected
          });
          setTableData(tableDataValue);
        }
      },
      style: headerStyle,
      children: /*#__PURE__*/_jsx("input", {
        id: `${randomHeaderCheckboxId}_kc-ui-header-checkbox`,
        name: `${randomHeaderCheckboxId}_kc-ui-header-checkbox`,
        type: "checkbox"
      })
    });
  }
  return /*#__PURE__*/_jsxs("li", {
    title: item.tite,
    className: `${item.sort ? "kc-ui-cursor" : ""} ${sortField === sortByKey ? "kc-ui-table-sorted" : ""}`,
    style: headerStyle,
    onClick: () => item.sort ? onTriggerHeaderClick(item) : null,
    children: [/*#__PURE__*/_jsx(TranslateText, {
      id: item.title
    }), /*#__PURE__*/_jsx("i", {
      className: sortIcon
    })]
  });
};
const _TableRow = ({
  rowCount,
  column,
  tableData,
  value,
  props,
  onClickCheckbox,
  onClickColumn,
  setTableData
}) => {
  return /*#__PURE__*/_jsx("ul", {
    className: "tBody",
    children: column.map((item, index) => {
      const rowStyle = {
        textAlign: item?.textAlign
      };
      const rowValue = /*#__PURE__*/_jsx("li", {
        style: rowStyle,
        className: item.progress ? 'kc-ui-table-progress' : 'kc-ui-table-li',
        onClick: () => onClickColumn({
          row: value,
          column: item
        }),
        children: item.progress ? /*#__PURE__*/_jsx("div", {
          className: "kc-ui-table-progress-bar",
          style: {
            width: `${value[item.progressKey]}%`,
            display: value[item.progressKey] === 0 ? 'contents' : ''
          },
          children: value[item.key]
        }) : item.key && item.key !== "" ? value[item.key] : item.type === HeaderValueType.AutoIncrement ? rowCount + 1 : ""
      }, 'header_' + index);
      if (item?.type === HeaderValueType.Image) {
        return /*#__PURE__*/_jsx("li", {
          style: rowStyle,
          onClick: () => onClickColumn({
            row: value,
            column: item
          }),
          children: /*#__PURE__*/_jsx("img", {
            className: "kc-ui-table-image",
            src: value[item.key]
          })
        }, 'header_' + index);
      } else if (item?.type === HeaderValueType.Checkbox) {
        const randomCheckboxId = (Math.random() + 1).toString(36).substring(5);
        return /*#__PURE__*/_jsx("li", {
          style: rowStyle,
          className: `kc-ui-checkbox ${value[item.key] ? 'checked' : ''}`,
          onClick: () => {
            if (onClickCheckbox) {
              let tableDataValue = tableData.map((prevData, index) => {
                if (index === rowCount) {
                  return {
                    ...prevData,
                    [item.key]: !value[item.key]
                  };
                }
                return prevData;
              });
              let allSelected = false;
              const checkedNewData = tableDataValue.filter(i => i[item.key] === true).length;
              if (checkedNewData !== 0 && checkedNewData === tableData.length) {
                allSelected = true;
              }
              onClickCheckbox({
                items: tableDataValue?.filter(i => i[item.key] === true),
                column: item,
                allSelected
              });
              setTableData(tableDataValue);
            }
          },
          children: /*#__PURE__*/_jsx("input", {
            id: `${randomCheckboxId}_kc-ui-table-checkbox_${index}`,
            value: value[item.key],
            name: `${randomCheckboxId}_kc-ui-table-checkbox_${index}`,
            type: "checkbox"
          })
        }, 'header_' + index);
      } else if (item?.type === HeaderValueType.DetailRow) {
        return /*#__PURE__*/_jsx("li", {
          style: rowStyle,
          children: /*#__PURE__*/_jsx("a", {
            onClick: () => {
              let classList = document.getElementById(`${detailRowRandomId}_detailRow_` + rowCount)?.classList;
              if (classList?.contains('active')) {
                classList.remove('active');
              } else {
                classList ? classList.add('active') : '';
              }
            },
            className: "btn collapseExpand collapsed",
            children: "\xA0"
          })
        }, 'header_' + index);
      } else if (item?.type === HeaderValueType.ExternalLink) {
        return /*#__PURE__*/_jsx("li", {
          style: rowStyle,
          children: /*#__PURE__*/_jsx("a", {
            href: value[item.key],
            target: "blank",
            className: "btn kc-ui-externalLink",
            children: "\xA0"
          })
        }, 'header_' + index);
      } else if (item?.type === HeaderValueType.Color) {
        return /*#__PURE__*/_jsx("li", {
          style: {
            padding: '8px',
            textAlign: 'center',
            justifyContent: 'center',
            display: 'flex'
          },
          children: /*#__PURE__*/_jsx("div", {
            style: {
              backgroundColor: value[item.key],
              width: '30%',
              height: '15px',
              margin: 8
            }
          })
        }, 'header_' + index);
      } else if (props && props.children && props.children.length) {
        const isVal = props.children.filter(i => i.key === item.key);
        const isIndex = props.children.findIndex(i => i.key === item.key);
        if (isVal && isVal.length) {
          return /*#__PURE__*/_jsx("li", {
            style: rowStyle,
            onClick: () => onClickColumn({
              row: value,
              column: item
            }),
            children: props.children[isIndex].props.children(item, value)
          }, 'header_' + index);
        } else {
          return rowValue;
        }
      } else {
        return rowValue;
      }
    })
  });
};
const _TableDetailsRow = ({
  rowCount,
  column,
  value,
  props
}) => {
  if (!value) {
    return /*#__PURE__*/_jsx("div", {});
  }
  return value?.length ? /*#__PURE__*/_jsx("div", {
    id: `${detailRowRandomId}_detailRow_` + rowCount,
    className: "kc-ui-table-detail-widget kc-ui-detail-row-content",
    children: value.map((detailValue, detailIndex) => {
      const value = detailValue;
      return /*#__PURE__*/_jsx("ul", {
        className: "tBody",
        children: column.map((item, index) => {
          const rowStyle = {
            textAlign: item?.textAlign
          };
          const rowValue = /*#__PURE__*/_jsx("li", {
            style: rowStyle,
            children: item.key && item.key !== "" ? value[item.key] : ""
          }, 'header_' + index + '_' + detailIndex);
          if (item?.type === HeaderValueType.Image) {
            return /*#__PURE__*/_jsx("li", {
              style: rowStyle,
              children: /*#__PURE__*/_jsx("img", {
                className: "kc-ui-table-image",
                src: value[item.key]
              })
            }, 'header_' + index + '_' + detailIndex);
          } else if (item?.type === HeaderValueType.Checkbox) {
            return /*#__PURE__*/_jsx("li", {
              style: rowStyle
            }, 'header_' + index + '_' + detailIndex);
          } else if (item?.type === HeaderValueType.DetailRow) {
            return /*#__PURE__*/_jsx("li", {
              style: rowStyle
            }, 'header_' + index + '_' + detailIndex);
          } else if (props && props.children && props.children.length) {
            const isVal = props.children.filter(i => i.key === item.key);
            const isIndex = props.children.findIndex(i => i.key === item.key);
            if (isVal && isVal.length) {
              return /*#__PURE__*/_jsx("li", {
                style: rowStyle,
                children: props.children[isIndex].props.children(item, value)
              }, 'header_' + index + '_' + detailIndex);
            } else {
              return rowValue;
            }
          } else {
            return rowValue;
          }
        })
      }, detailIndex);
    })
  }) : /*#__PURE__*/_jsx("div", {});
};
const _Table = ({
  column,
  value,
  props,
  noValueText,
  searchText,
  onClickCheckbox,
  onClickColumn,
  defaultSort
}) => {
  const [sortField, setSortField] = React.useState('');
  const [sortOrder, setSortOrder] = React.useState(SortByType.Asc);
  const [tableData, setTableData] = React.useState([]);
  React.useEffect(() => {
    if (searchText && searchText !== "") {
      const results = value.filter(object => Object.values(object).some(i => i && typeof i === "string" && i.includes(searchText)));
      setTableData(results);
    } else {
      if (defaultSort?.key !== "") {
        const sortByKey = defaultSort?.key;
        const sortOrderValue = defaultSort?.sortBy ? defaultSort?.sortBy : SortByType.Asc;
        let orderedList = value && sortByKey && sortByKey !== "" ? value.sort((a, b) => {
          if (a[sortByKey] > b[sortByKey]) {
            return sortOrderValue === SortByType.Asc ? 1 : -1;
          } else if (a[sortByKey] < b[sortByKey]) {
            return sortOrderValue === SortByType.Asc ? -1 : 1;
          } else {
            return 0;
          }
        }) : value;
        setSortField(defaultSort?.key);
        setSortOrder(defaultSort?.sortBy);
        setTableData(orderedList);
      } else {
        setTableData(value);
      }
    }
  }, [searchText, value]);
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "kc-ui-table-widget",
      children: [/*#__PURE__*/_jsx("ul", {
        className: "tHead",
        children: column.map((h, index) => {
          return /*#__PURE__*/_jsx(_TableHeadItem, {
            item: h,
            sortField: sortField,
            setSortField: setSortField,
            sortOrder: sortOrder,
            setSortOrder: setSortOrder,
            tableData: tableData,
            setTableData: setTableData,
            onClickCheckbox: onClickCheckbox
          }, index);
        })
      }), tableData && tableData.length && typeof tableData === "object" ? tableData.map((item, index) => {
        const isDetailRow = column.find(i => i.type === HeaderValueType.DetailRow);
        return /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsx(_TableRow, {
            rowCount: index,
            tableData: tableData,
            value: item,
            column: column,
            props: props,
            onClickCheckbox: onClickCheckbox,
            onClickColumn: onClickColumn,
            setTableData: setTableData
          }, 'data_' + index), isDetailRow && /*#__PURE__*/_jsx(_TableDetailsRow, {
            rowCount: index,
            value: item[isDetailRow.key],
            column: column,
            props: props
          }, 'data_detail_' + index)]
        }, index);
      }) : null]
    }), !tableData || !tableData.length || typeof tableData !== "object" ? /*#__PURE__*/_jsx("p", {
      className: "kc-ui-align-no-result kc-ui-align-center",
      children: /*#__PURE__*/_jsx(TranslateText, {
        id: noValueText
      })
    }) : null]
  });
};
const _TableWidget = props => {
  const {
    loader,
    title,
    width,
    search,
    defaultSort,
    searchPlaceholder,
    toolbarControls,
    onTriggerToolbarControlClick,
    filter,
    filterOptions,
    onTriggerFilterChange,
    noValueText,
    value,
    column,
    disabled,
    dateFilterTitle,
    dateFilter,
    dateFilterOptions,
    dateFilterValue,
    onTriggerDateFilterChange,
    dateFilterDateFormat,
    onTriggerColumnClick,
    onTriggerCheckboxChange,
    pagination,
    totalRecords,
    pageSize,
    pageNumber,
    onTriggerPaginationChange,
    showHintMessage,
    hintMessage
  } = props;
  const [searchText, setSearchText] = React.useState('');
  const [totalNumberOfRecords, setTotalRecords] = React.useState(totalRecords);
  const [checkboxFilterOptions, setCheckboxFilterOptions] = React.useState(filterOptions);
  const intl = useIntl();
  React.useEffect(() => {
    setCheckboxFilterOptions(filterOptions);
    setTotalRecords(totalRecords);
  }, [filterOptions, pageNumber, totalRecords]);
  const onClickFilterCheckbox = element => {
    if (onTriggerFilterChange) {
      setCheckboxFilterOptions(prevData => {
        let newData = prevData.map(item => {
          if (item.label === element.label) {
            return {
              ...item,
              checked: !element.checked
            };
          }
          return item;
        });
        onTriggerFilterChange({
          data: {
            items: newData?.filter(i => i.checked)
          }
        });
        return newData;
      });
    }
  };
  const onClickToolbar = element => {
    if (onTriggerToolbarControlClick) {
      onTriggerToolbarControlClick({
        data: element
      });
    }
  };
  const onClickCheckbox = element => {
    if (onTriggerCheckboxChange) {
      onTriggerCheckboxChange({
        data: element
      });
    }
  };
  const onClickColumn = element => {
    if (onTriggerColumnClick) {
      onTriggerColumnClick({
        data: element
      });
    }
  };
  return /*#__PURE__*/_jsx(React.Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      className: `kc-ui-colm kc-ui-table ${disabled && "kc-ui-disabled "} ${loader && "kc-ui-loader-overlay"}`,
      style: {
        width: `${width}`
      },
      children: /*#__PURE__*/_jsxs("div", {
        className: "kc-ui-colm-div",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "kc-ui-table-wrapper",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "kc-ui-flex kc-ui-table-title-header",
            children: [title ? /*#__PURE__*/_jsx("h4", {
              children: /*#__PURE__*/_jsx(TranslateText, {
                id: title
              })
            }) : null, /*#__PURE__*/_jsx("div", {
              className: "kc-ui-checkbox-list-grp kc-ui-flex",
              children: filter ? checkboxFilterOptions && checkboxFilterOptions.length && typeof checkboxFilterOptions === "object" ? checkboxFilterOptions.map((checkbox, index) => {
                const randomFilterCheckboxId = (Math.random() + 1).toString(36).substring(6);
                const checkboxClass = `kc-ui-filter-${checkbox.type === FilterTypeProps.Danger || checkbox.type === FilterTypeProps.Warning ? checkbox.type : 'default'}${checkbox.checked ? `-checked` : ''}`;
                return /*#__PURE__*/_jsxs("div", {
                  className: `kc-ui-flex kc-ui-checkboxListIndex ${checkboxClass}`,
                  onClick: () => onClickFilterCheckbox(checkbox),
                  children: [/*#__PURE__*/_jsx("input", {
                    className: `kc-ui-errorCheckbox kc-checkbox-${checkbox.type}`,
                    id: `${randomFilterCheckboxId}_${checkbox.label}`,
                    type: "checkbox",
                    value: checkbox.label
                  }), /*#__PURE__*/_jsxs("div", {
                    className: "kc-ui-checkbox-list-div",
                    children: [/*#__PURE__*/_jsx("span", {
                      children: /*#__PURE__*/_jsx(TranslateText, {
                        id: checkbox.label
                      })
                    }), /*#__PURE__*/_jsx("span", {
                      children: /*#__PURE__*/_jsx(TranslateText, {
                        id: checkbox.text
                      })
                    })]
                  })]
                }, index);
              }) : null : showHintMessage && /*#__PURE__*/_jsx("div", {
                className: "kc-ui-tablehintmessage-div",
                children: /*#__PURE__*/_jsx(HintMessage, {
                  hintMessage: hintMessage
                })
              })
            }), dateFilter && /*#__PURE__*/_jsx("div", {
              className: "kc-ui-datefilter-div kc-ui-table-datefilter-alignment",
              children: /*#__PURE__*/_jsx(DateFilter, {
                options: dateFilterOptions,
                title: dateFilterTitle,
                value: dateFilterValue,
                onTriggerChange: onTriggerDateFilterChange,
                dateFormat: dateFilterDateFormat
              })
            }), toolbarControls && toolbarControls.length ? /*#__PURE__*/_jsx("div", {
              className: "kc-ui-flex kc-ui-toolbar-div",
              children: toolbarControls.map((button, index) => /*#__PURE__*/_jsx("button", {
                onClick: () => onClickToolbar(button),
                className: "kc-ui-table-button",
                children: /*#__PURE__*/_jsx(TranslateText, {
                  id: button.label
                })
              }, index))
            }) : null]
          }), filter && showHintMessage && /*#__PURE__*/_jsx("div", {
            className: "kc-ui-tablehintmessage-div",
            children: /*#__PURE__*/_jsx(HintMessage, {
              hintMessage: hintMessage
            })
          }), search && /*#__PURE__*/_jsx("input", {
            type: "text",
            className: "kc-ui-search-box",
            placeholder: searchPlaceholder ? intl.formatMessage({
              id: searchPlaceholder
            }) : '',
            value: searchText,
            onChange: e => setSearchText(e.target.value)
          }), column && column.length && typeof column === "object" ? loader ? /*#__PURE__*/_jsx(Loader, {
            loader: loader
          }) : /*#__PURE__*/_jsx(_Table, {
            column: column,
            value: value,
            props: props,
            noValueText: noValueText,
            searchText: searchText,
            onClickCheckbox: onClickCheckbox,
            onClickColumn: onClickColumn,
            defaultSort: defaultSort
          }) : null]
        }), pagination && !loader && /*#__PURE__*/_jsx(Pagination, {
          totalRecords: totalNumberOfRecords,
          pageSize: pageSize,
          pageNumber: pageNumber,
          onTriggerPaginationChange: onTriggerPaginationChange
        })]
      })
    })
  });
};
_TableWidget.defaultProps = {
  loader: false,
  title: '',
  width: '100%',
  search: false,
  searchPlaceholder: 'Search',
  disabled: false,
  toolbarControls: [],
  defaultSort: {
    key: '',
    sortBy: ''
  },
  onTriggerToolbarControlClick: () => {},
  filter: false,
  filterOptions: [],
  column: [],
  noValueText: '',
  value: [],
  onTriggerFilterChange: () => {},
  dateFilterTitle: '',
  dateFilter: false,
  dateFilterOptions: [],
  onTriggerDateFilterChange: () => {},
  dateFilterValue: {},
  dateFilterDateFormat: "MM/dd/yyyy",
  pagination: false,
  pageSize: 10,
  totalRecords: 0,
  pageNumber: 1,
  onTriggerPaginationChange: () => {}
};
export const TableWidget = injectIntl( /*#__PURE__*/React.memo(_TableWidget));